/*
 * @Description:
 * @Author: jia.chen02
 * @Date: 2024-04-02 14:23:17
 * @LastEditors: 莫 飞湖 feihu.mo@za.group
 * @LastEditTime: 2024-08-05 19:28:01
 */
import { createApp } from "vue";
import { createPinia } from "pinia";
import { createI18n } from "vue-i18n";
import App from "./App.vue";
import router from "./router";
import { ElLoading, ElDatePicker } from "element-plus";
import { registerMicroApps, start } from "qiankun";
import axios from "@/utils/request";
import "@/styles/index.scss";
import "default-passive-events";
import en from "@/language/en";
import cn from "@/language/zh-cn";
import hk from "@/language/zh-hk";

const pinia = createPinia();
const language = localStorage.getItem("language") || "cn";

const i18n = createI18n({
  locale: language, // 设置当前语言环境
  fallbackLocale: "cn", // 当前语言环境未匹配到时，回退到的语言环境
  messages: {
    en,
    cn,
    hk,
  },
});
ElDatePicker.props.unlinkPanels = {
  type: Boolean,
  default: true,
};

createApp(App)
  .use(i18n)
  .use(pinia)
  .use(router)
  .use(ElLoading)
  .use(ElDatePicker)
  .mount("#app");
//  可以考虑做一个select 下拉框全部配置。目前是固定写高度

const isDev = process.env?.NODE_ENV === "development";

registerMicroApps([
  {
    name: "kc-app", // app name registered
    entry: isDev ? `//localhost:8102` : `/micro-sub-demo/`,
    // entry: `/micro-sub-demo/`,
    container: "#kc-container",
    activeRule: "/lowcode",
    props: {
      request: axios,
    },
  },
  // {
  //   name: "vue app",
  //   entry: { scripts: ["//localhost:7100/main.js"] },
  //   container: "#yourContainer2",
  //   activeRule: "/yourActiveRule2",
  // },
]);

start();
